import MyCustomerVue from '@/views/sa/my-customer/my-customer.vue';

const basePath = '/sa/my-customer';
const role = 'sa'; // 角色身份

export const SA_MY_CUSTOMER_INDEX = 'sa-my-customer-index';
export const SA_MY_CUSTOMER_RESERVATION_EDIT = 'sa-my-customer-reservation-edit';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: MyCustomerVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index/:userId`,
      name: SA_MY_CUSTOMER_INDEX,
      props: true,
      component: () => import(
        /* webpackChunkName: "my-customer-index" */
        `@/views/${role}/my-customer/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/edit/:id`,
      name: SA_MY_CUSTOMER_RESERVATION_EDIT,
      props: true,
      component: () => import(
        /* webpackChunkName: "my-customer-reservation-edit" */
        `@/views/${role}/my-customer/edit.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
